import React from "react";
import ProductCards from "../../Components/ProductCards";
import Banner from "../Banner/Banner";
import Footer from "./../../Components/Footer";
import Header from "./../../Components/Header";
import meatData from "./meatData";
import ShopBy from "../../Components/ShopbyComponent";
import FilterList from "../../Components/FilterList";



const MeatPage = () => {
  
  return (
    <>
      <Header />
      
      <Banner categories={"Categories/"} title={"Meat&Fish"} />
      <div className="fruits section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
              <ShopBy/>
            </div>

            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
              <FilterList/>

              <div className="row">
                {meatData.map((meat) => (
                  <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 my-3">
                    <ProductCards
                      id={meat.id}
                      title={meat.title}
                      image={meat.img}
                      rating={meat.rating}
                      price={meat.price}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MeatPage;
